import * as yup from "yup";

import { t } from "@/i18n-js/instance";

export const MAX_POLL_OPTIONS_COUNT = 5;

const uniqueOptionValues = (options: any) => {
  const uniqueValues = new Set(
    options.map((option: any) => option.value.trim()),
  );
  return uniqueValues.size === options.length;
};

export const getPollValidationSchema = (initialClosesAt?: string | null) =>
  yup.object().shape({
    title: yup
      .string()
      .required(t("tiptap.extensions.poll.validation_errors.title_required")),
    poll_options: yup
      .array()
      .of(
        yup.object().shape({
          value: yup
            .string()
            .required(
              t(
                "tiptap.extensions.poll.validation_errors.option_value_required",
              ),
            ),
        }),
      )
      .min(2, t("tiptap.extensions.poll.validation_errors.options_minimum"))
      .max(
        MAX_POLL_OPTIONS_COUNT,
        t("tiptap.extensions.poll.validation_errors.options_maximum", {
          maximum: MAX_POLL_OPTIONS_COUNT,
        }),
      )
      .test(
        "unique-option-values",
        t("tiptap.extensions.poll.validation_errors.options_unique"),
        uniqueOptionValues,
      )
      .required(t("tiptap.extensions.poll.validation_errors.options_minimum")),
    enable_poll_duration: yup.boolean().required(),
    closes_at: yup
      .string()
      .nullable()
      .when("enable_poll_duration", {
        is: true,
        then: schema =>
          schema
            .required(
              t("tiptap.extensions.poll.validation_errors.closes_at_required"),
            )
            .test(
              "closes-at-in-future",
              t(
                "tiptap.extensions.poll.validation_errors.closes_at_must_be_in_future",
              ),
              value => {
                if (!value) return false;
                if (initialClosesAt && value === initialClosesAt) return true;
                return new Date(value) > new Date();
              },
            ),
        otherwise: schema => schema.nullable(),
      }),
  });

export const NEW_POLL_OPTION = {
  value: "",
};
